// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.EZDrawer .EZDrawer__checkbox {
    display: none;
}
.EZDrawer .EZDrawer__checkbox:checked ~ .EZDrawer__overlay {
    display: block;
    opacity: 1;
}
.EZDrawer .EZDrawer__checkbox:checked ~ .EZDrawer__container {
    visibility: visible;
    transform: translate3d(0, 0, 0) !important;
}
.EZDrawer .EZDrawer__overlay {
    display: none;
    height: 100vh;
    left: 0;
    position: fixed;
    top: 0;
    width: 100%;
}
.EZDrawer .EZDrawer__container {
    position: fixed;
    visibility: hidden;
    background: white;
    transition: all;
    box-shadow: 0 0 10px 5px rgba(0, 0, 0, 0.1);
}
`, "",{"version":3,"sources":["webpack://./node_modules/react-modern-drawer/dist/index.css"],"names":[],"mappings":"AAAA;IACI,aAAa;AACjB;AACA;IACI,cAAc;IACd,UAAU;AACd;AACA;IACI,mBAAmB;IACnB,0CAA0C;AAC9C;AACA;IACI,aAAa;IACb,aAAa;IACb,OAAO;IACP,eAAe;IACf,MAAM;IACN,WAAW;AACf;AACA;IACI,eAAe;IACf,kBAAkB;IAClB,iBAAiB;IACjB,eAAe;IACf,2CAA2C;AAC/C","sourcesContent":[".EZDrawer .EZDrawer__checkbox {\n    display: none;\n}\n.EZDrawer .EZDrawer__checkbox:checked ~ .EZDrawer__overlay {\n    display: block;\n    opacity: 1;\n}\n.EZDrawer .EZDrawer__checkbox:checked ~ .EZDrawer__container {\n    visibility: visible;\n    transform: translate3d(0, 0, 0) !important;\n}\n.EZDrawer .EZDrawer__overlay {\n    display: none;\n    height: 100vh;\n    left: 0;\n    position: fixed;\n    top: 0;\n    width: 100%;\n}\n.EZDrawer .EZDrawer__container {\n    position: fixed;\n    visibility: hidden;\n    background: white;\n    transition: all;\n    box-shadow: 0 0 10px 5px rgba(0, 0, 0, 0.1);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
